import { defineComponent as _defineComponent } from 'vue'
import TG4Loader from '@/components/TG4Loader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DynamicRailLoadingState',
  props: {
    message: null,
    loading: { type: Boolean }
  },
  setup(__props: any) {




return { __sfc: true,TG4Loader }
}

})